import { onBeforeUnmount } from '@vue/composition-api'

export function regisitPageshowFn(): void {
  window.addEventListener('pageshow', wkWebviewHandler)
  onBeforeUnmount(() => {
    removePageshowFn()
  })
}

export function removePageshowFn(): void {
  window.removeEventListener('pageshow', wkWebviewHandler)
}

function wkWebviewHandler(e) {
  if (e.persisted) {
    window.location.reload()
  }
}
